// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","6005":"3e74ce74","6818":"06bb381e"}[chunkId] || chunkId) + "." + {"1047":"bce09b0bf47987c9","2741":"b6adcfd3021dbccd","2937":"e7601066ca3501ac","6005":"6712f274b1e3f1b7","6818":"b04980422a119373","7127":"b9b7a0054d3c527a","9651":"4bb37ba6f1224ce4"}[chunkId] + ".js";
};